<div class="credit-result">

  <div class="row">
    <div class="col-12"
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="space-between start"
      fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="center start">
      <div class="mat-h3">Result</div>
      @if (!creditFlowResult.length && isAdminOrCreditUser) {
        <button mat-flat-button [disabled]="notSubmitted" class="active w-lt-md-100" (click)="runCreditFlow()">Run Credit Flow</button>
      }
      @else if (isAdminOrCreditUser) {
        <button mat-flat-button class="active w-lt-md-100" (click)="runCreditFlow()">Rerun Credit Flow</button>
      }
    </div>
  </div>
  @if (!creditFlowResult.length) {
    @if (approvalReadiness && !approvalReadiness.kybPassed) {
      <message-box type="warn">
        KYB is unresolved. Credit approval is still available, but requires an audited acknowledgement.
      </message-box>
    }
    <div class="row mb-4">
      <div class="col-lg-6 col-md-12">
        <message-box fxFlex="grow" type="warn">Credit flow has not started</message-box>
      </div>
    </div>
  }
  @if (creditOfficerRerunDecision) {
    <div class="row mb-4">
      <div class="col-auto">
        <message-box type="info">
          <span class="rerun-note">Credit flow has been rerun, <strong>{{ creditOfficerRerunDecision }}</strong> recommend, please review</span>
        </message-box>
      </div>
    </div>
  } @else {
    @if (creditFlowResult.length && !(creditFlowResult[creditFlowResult.length - 1].completeFlow)) {
      <div class="row mb-4">
        <div class="col-lg-6 col-md-12">
          <message-box fxFlex="grow" type="info">Credit flow was not completed</message-box>
        </div>
      </div>
    }
    @if (creditFlowResult.length && creditFlowResult[creditFlowResult.length - 1].completeFlow) {
      <div class="row mb-4">
        <div class="col-lg-6 col-md-12">
          <message-box fxFlex="grow" type="success">Credit flow has been completed</message-box>
        </div>
      </div>
    }
  }
  <div class="row mb-2 result-item">
    <div class="col-lg-3 col-md-12">
      <div class="title">System Decision: </div>
    </div>
    <div class="col-lg-6 col-md-12">
      <div fxLayout="row"
        fxLayoutGap="10px"
        fxLayoutAlign="start center">
        <tag-box [state]="application.SystemCreditStatus ?? ''"></tag-box>
        <div>{{creditFlowResult.length ? ((creditFlowResult[creditFlowResult.length - 1].lastUpdatedTime) | date:'dd/MM/yyyy h:mm a') : ''}}</div>
      </div>
    </div>
  </div>
  @if (creditFlowResult.length && !(creditFlowResult[creditFlowResult.length - 1].completeFlow) && isAdminOrCreditUser) {
    <div class="row mb-2 result-item">
      <div class="col-lg-3 col-md-12">
        <div class="title">Resume Credit Flow</div>
      </div>
      <div class="col-lg-6 col-md-12">
        <span class="mdi mdi-refresh cursor-pointer" (click)="resumeCreditFlow()"></span>
      </div>
    </div>
  }
  <div class="row mb-2 result-item">
    <div class="col-lg-3 col-md-12">
      <div class="title">Credit Officer Decision: </div>
    </div>
    <div class="col-lg-6 col-md-12">
      <tag-box [state]="application.CreditOfficerStatus ?? ''"></tag-box>
    </div>
  </div>
  <div class="row mb-2 result-item">
    <div class="col-lg-3 col-md-12">
      <div class="title">Credit Officer: </div>
    </div>
    <div class="col-lg-6 col-md-12">
      <div>{{creditOfficer}}</div>
    </div>
  </div>
  @if (isAssetFinanceApplication()) {
    <div class="row mb-2 result-item">
      <div class="col-lg-3 col-md-12">
        <div class="title">Product Type: </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div>{{toDisplayProductType(currentProductTypeValue())}}</div>
      </div>
    </div>
  }
  @if (application.ExposureAtSubmission !== null && application.ExposureAtSubmission !== undefined) {
    <div class="row mb-2 result-item">
      <div class="col-lg-3 col-md-12">
        <div class="title">Exposure at Submission: </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
          <span>{{application.ExposureAtSubmission | looseCurrency}}</span>
          @if (isAdminOrCreditUser) {
            <span
              class="mdi mdi-refresh cursor-pointer"
              [class.disabled]="recalculatingExposureAtSubmission"
              matTooltip="Recalculate exposure at submission"
              (click)="recalculateExposureAtSubmission()"
            ></span>
          }
        </div>
      </div>
    </div>
  }
  @if (application.AppInfo.StageName === 'Closed Lost') {
    <div class="row mb-2 result-item">
      <div class="col-lg-3 col-md-12">
        <div class="title">Lost Reason Category:</div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div>{{application.CreditDeclineDetails?.lostCategory ?? ''}}</div>
      </div>
    </div>
    <div class="row mb-2 result-item">
      <div class="col-lg-3 col-md-12">
        <div class="title">Lost Reason Details:</div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div>{{application.CreditDeclineDetails?.lostReason ?? ''}}</div>
      </div>
    </div>
    <div class="row mb-2 result-item">
      <div class="col-lg-3 col-md-12">
        <div class="title">Lost Comment:</div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div>{{application.CreditDeclineDetails?.comment ?? ''}}</div>
      </div>
    </div>
  }
  @if (application.CreditOfficerStatus === 'Approved' || application.SystemCreditStatus === 'Approved') {
    <div class="row mb-2 result-item">
      <div class="col-lg-3 col-md-12">
          <div class="title">Valuation Source:</div>
        </div>
      <div class="col-lg-6 col-md-12">
        <div>{{application.CreditApprovedDetails?.valuationSource ?? ''}}</div>
      </div>
    </div>
    <div class="row mb-2 result-item">
      <div class="col-lg-3 col-md-12">
        <div class="title">Approval Conditions:</div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div>{{application.CreditApprovedDetails?.approvalConditions ?? ''}}</div>
      </div>
    </div>
      <div class="row mb-2 result-item">
      <div class="col-lg-3 col-md-12">
        <div class="title">Credit Reference: </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div>{{application.CreditApprovedDetails?.creditReference ?? ''}}</div>
      </div>
    </div>
    <div class="row mb-2 result-item">
      <div class="col-lg-3 col-md-12">
        <div class="title">Deal Status:</div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div>{{application.CreditApprovedDetails?.dealStatus ?? ''}}</div>
      </div>
    </div>
    <div class="row mb-2 result-item">
      <div class="col-lg-3 col-md-12">
        <div class="title">Exception To Policy: </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div>{{application.CreditApprovedDetails?.exceptionToPolicy ?? ''}}</div>
      </div>
    </div>
  }
  <mat-divider [inset]="true" class="mb-4 mt-4"></mat-divider>

  @if (isAdminOrCreditUser){
    <div class="row mb-2">
      <div class="col-12">
        <div class="mat-h3">Actions</div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12"
        fxLayout="row wrap"
        fxLayoutGap="10px"
        fxLayoutAlign="start start"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="center start">
        <!-- Wrapped in a span so the tooltip still shows while the button is disabled -->
        <span [matTooltip]="approveDisabledTooltip" [matTooltipDisabled]="!approveDisabled">
          <button mat-flat-button color="primary" [disabled]="approveDisabled" class="inactive w-lt-md-100 mb-2" (click)="onCreditApprove()">Approve</button>
        </span>
        <button mat-flat-button color="primary" [disabled]="notSubmitted" class="inactive w-lt-md-100 mb-2" (click)="onDecline()">Decline</button>
        <button mat-flat-button color="primary" [disabled]="notSubmitted" class="inactive w-lt-md-100 mb-2" (click)="moreInformation()">More Information</button>
        <button mat-flat-button color="primary" [disabled]="notSubmitted" class="inactive w-lt-md-100 mb-2" (click)="requestForBankStatements()">Request Bank Statements</button>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12"
        fxLayout="row wrap"
        fxLayoutGap="10px"
        fxLayoutAlign="start start"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="center start">
        <button mat-flat-button class="inactive w-lt-md-100 mb-2" (click)="takeOwnership()">Take Ownership</button>
        <button mat-flat-button class="inactive w-lt-md-100 mb-2" (click)="assignCreditOfficer()">Assign Credit Officer</button>
        @if (isAdminOrCreditUser) {
          <button mat-flat-button class="inactive w-lt-md-100 mb-2" (click)="copyApplicationSummary()">Copy Application Summary</button>
        }
      </div>
    </div>


    <mat-divider [inset]="true" class="mb-4"></mat-divider>
  }

  

  <div class="row mb-2">
    <div class="col-12">
      <div class="mat-h3">Alerts</div>
    </div>
  </div>

  <credit-result-alerts
    [creditFlowResult]="creditFlowResult"
    [application]="application"
    [parties]="parties"
  ></credit-result-alerts>
  
  <mat-divider [inset]="true" class="mb-4"></mat-divider>

  <div class="row mb-2">
    <div class="col-12">
      <div class="mat-h3">Services</div>
    </div>
  </div>

  <credit-result-web-services
    [data]="webServices"
    [application]="application"
    [parties]="parties"
    [downloadCreditorWatchReportFn]="downloadCreditorWatchReportFn"
    [getCreditWebServicesFn]="getCreditWebServicesFn"
    [apiUrl]="apiUrl"
    (viewReport)="onViewReport($event)"
  ></credit-result-web-services>

  <mat-divider [inset]="true" class="mb-4"></mat-divider>

  <div class="row mb-2">
    <div class="col-12">
      <div class="mat-h3">Historical Contracts</div>
    </div>
  </div>

  <mat-accordion>
    <mat-expansion-panel (opened)="openHistoricalContracts()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          FISCAL Contracts
        </mat-panel-title>
      </mat-expansion-panel-header>
      <credit-result-historical-contracts
        [application]="application"
        [getHistoricalContractsFn]="getHistoricalContractsFn"
      ></credit-result-historical-contracts>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-divider [inset]="true" class="mb-4"></mat-divider>

  <mat-accordion>
    <mat-expansion-panel (opened)="openPismoContracts()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          PISMO Contracts
        </mat-panel-title>
      </mat-expansion-panel-header>
      <credit-result-pismo-contracts
        [application]="application"
        [getPismoContractsFn]="getPismoContractsFn"
        (clickPismoAccountEvent)="onClickPismoAccount($event)"
      ></credit-result-pismo-contracts>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-divider [inset]="true" class="mb-4"></mat-divider>

  <div class="row mb-2">
    <div class="col-12">
      <div class="mat-h3">Associated Applications</div>
    </div>
  </div>

  <mat-accordion>
    <mat-expansion-panel (opened)="openDuplicatedApplications()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          List of Associated Applications
        </mat-panel-title>
      </mat-expansion-panel-header>
      <duplicated-applications
        [duplicatedApplications]="duplicatedApplications"
        (clickApplicationEvent)="onClick($event)"
      ></duplicated-applications>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-divider [inset]="true" class="mb-4"></mat-divider>

  <div class="row mb-2">
    <div class="col-12">
      <div class="mat-h3">Associated Entities</div>
    </div>
  </div>

  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          List of Associated Entities ({{ application.AssociatedEntities?.length || 0 }})
        </mat-panel-title>
      </mat-expansion-panel-header>
      @if (application.AssociatedEntities?.length) {
        <div class="table-responsive">
          <table mat-table [dataSource]="application.AssociatedEntities || []" class="width-full">
            <ng-container matColumnDef="abn">
              <th mat-header-cell *matHeaderCellDef>ABN</th>
              <td mat-cell *matCellDef="let element">{{ element.abn }}</td>
            </ng-container>
            <ng-container matColumnDef="acn">
              <th mat-header-cell *matHeaderCellDef>ACN</th>
              <td mat-cell *matCellDef="let element">{{ element.acn }}</td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Entity Name</th>
              <td mat-cell *matCellDef="let element">{{ element.name }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="['abn', 'acn', 'name']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['abn', 'acn', 'name']"></tr>
          </table>
        </div>
      } @else {
        <p class="mt-2">No associated entities found. Run the credit flow to populate this list.</p>
      }
    </mat-expansion-panel>
  </mat-accordion>

  <div class="row mb-2 mt-4">
    <div class="col-12">
      <div class="mat-h3">Credit Notes</div>
    </div>
  </div>

  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Notes
        </mat-panel-title>
      </mat-expansion-panel-header>
      <asset-notes
        [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [onlyShowNotes]="true"
        [alwaysInternalNotes]="true"
        [showInternalOnlyButton]="false"
        [creditNotesOnly]="true"
      ></asset-notes>
    </mat-expansion-panel>
  </mat-accordion>


  <div class="row mb-2 mt-4">
    <div class="col-12">
      <div class="mat-h3">Other Information</div>
    </div>
  </div>

  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Credit Flow Details
        </mat-panel-title>
      </mat-expansion-panel-header>
      <credit-flow-details
        [creditFlowResult]="creditFlowResult"
      ></credit-flow-details>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Audit Log
        </mat-panel-title>
      </mat-expansion-panel-header>
      <credit-audit-log
        [application]="application"
        [getCreditAuditLogFn]="getCreditAuditLogFn"
      ></credit-audit-log>
    </mat-expansion-panel>
  </mat-accordion>

</div>
